import { useState } from "react";
import { Box, Stack, Typography, Grid, Chip, Tabs, Tab } from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import VILLAS from "../landing/Villas/constants";

const VillasList = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const filterVillas = () => {
    switch (selectedTab) {
      case 1: // 5BHK
        return VILLAS.filter((villa) => villa.title.includes("5BHK"));
      case 2: // 4BHK
        return VILLAS.filter((villa) => villa.title.includes("4BHK"));
      default: // All
        return VILLAS;
    }
  };

  const filteredVillas = filterVillas();

  return (
    <>
      <Navbar />
      <Box
        maxWidth={1200}
        mx="auto"
        pt={{ xs: 18, sm: 24 }}
        pb={{ xs: 8, sm: 16 }}
        width={{ xs: "90%", lg: "100%" }}
        minHeight="100vh"
      >
        {/* Header */}
        <Box textAlign="center" mb={8}>
          <Typography 
            color="#ffffff70" 
            textAlign="center" 
            mt={1}
            data-aos="fade-up"
          >
            VILLAS
          </Typography>
          <Typography
            variant="h1"
            typography={{ xs: "h2", sm: "h1" }}
            sx={{ fontWeight: "700 !important" }}
            color="text.primary"
            mb={2}
            mt={1}
            data-aos="fade-up"
            data-aos-delay={100}
          >
            OUR STAYS
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            maxWidth={600}
            mx="auto"
            data-aos="fade-up"
            data-aos-delay={200}
          >
            Discover our collection of premium vacation rental villas in North
            Goa
          </Typography>
        </Box>

        {/* Tab Switcher */}
        <Box 
          display="flex" 
          justifyContent="center" 
          mb={6}
          data-aos="fade-up"
          data-aos-delay={300}
        >
          <Box
            sx={{
              bgcolor: "rgba(255, 255, 255, 0.1)",
              borderRadius: 100,
              p: 0.5,
              backdropFilter: "blur(10px)",
            }}
          >
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{
                minHeight: "auto",
                "& .MuiTabs-flexContainer": {
                  gap: 1,
                },
                "& .MuiTab-root": {
                  minHeight: "auto",
                  py: 1.5,
                  px: 4,
                  borderRadius: 100,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "1rem",
                  color: "white",
                  transition: "all 0.3s ease",
                  "&.Mui-selected": {
                    bgcolor: "white !important",
                    color: "text.primary !important",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  },
                  "&:hover:not(.Mui-selected)": {
                    bgcolor: "rgba(255, 255, 255, 0.1)",
                  },
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              <Tab label="All" />
              <Tab label="5BHK" />
              <Tab label="4BHK" />
            </Tabs>
          </Box>
        </Box>

        {/* Villas Grid */}
        <Box data-aos="fade-up" data-aos-delay={400}>
          <Grid container spacing={4} columns={{ xs: 4, md: 12 }}>
            {filteredVillas.map((villa, idx) => (
              <Grid item xs={4} key={villa.key}>
                <Link
                  to={villa.comingSoon ? "/" : villa.link}
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    data-aos="fade-up"
                    data-aos-delay={idx * 100}
                    sx={{
                      overflow: "hidden",
                      cursor: "pointer",
                      position: "relative",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                      },
                    }}
                  >
                    {villa.comingSoon && (
                      <Chip
                        label="Coming soon"
                        color="white"
                        sx={{
                          position: "absolute",
                          right: 12,
                          top: 12,
                          zIndex: 1,
                        }}
                      />
                    )}
                    {villa.isNew && (
                      <Chip
                        label="New"
                        color="white"
                        sx={{
                          position: "absolute",
                          left: 12,
                          top: 12,
                          zIndex: 1,
                        }}
                      />
                    )}
                    <picture>
                      <source srcSet={`${villa.img}.webp`} type="image/webp" />
                      <img
                        width="100%"
                        style={{ borderRadius: 24 }}
                        src={`${villa.img}.jpg`}
                        alt={villa.title}
                      />
                    </picture>
                    <Stack mt={2}>
                      <Typography variant="h5" fontWeight={600}>
                        {villa.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        {villa.description}
                      </Typography>
                    </Stack>
                  </Box>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Show message if no villas found */}
        {filteredVillas.length === 0 && (
          <Box textAlign="center" py={8}>
            <Typography variant="h6" color="text.secondary">
              No villas found for the selected category.
            </Typography>
          </Box>
        )}
      </Box>

      <Footer />
    </>
  );
};

export default VillasList;
